import { Button, Flex, H1, useBreadcrumbs } from "@inmagik/magik-ui"
import Layout from "../../components/Layout"
import { useNavigate, useParams } from "react-router-dom"
import { Formik } from "formik"
import { Container } from "react-bootstrap"
import BottomFormFixed from "../../components/BottomFormFixed"
import useModalTrigger from "magik-react-hooks/useModalTrigger"
import { useMemo } from "react"
import ModalDelete from "../../components/ModalDelete"
import { ScrollLayout } from "../../components/ScrollLayout"
import type { Output } from "../../types"
import { initialValuesOutput, validationSchemaOutput } from "./OutputCommon"
import { useDeleteOutput, useOutput, usePartialUpdateOutput } from "../../hooks/outputs"
import OutputForm from "./OutputForm"

export default function OutputUpdate() {
  const updateOutput = usePartialUpdateOutput()
  const navigate = useNavigate()

  const { id } = useParams()

  const { data: output } = useOutput(Number(id))

  const deleteOutput = useDeleteOutput()

  const [modalStateDeleteOutput, modalActionsDeleteOutput] = useModalTrigger()

  const initialValues = useMemo(() => initialValuesOutput(output), [output])
  const validationSchema = useMemo(() => validationSchemaOutput(), [])

  useBreadcrumbs([{ label: "Output", href: "/outputs/outputs" }, { label: "Dettaglio Output" }])

  return (
    <Layout>
      <ScrollLayout hasBottomFixed>
        <Flex alignItems="center" justifyContent="between">
          <H1>{output?.title}</H1>
          <Button
            size="md"
            variant="danger"
            title="Elimina"
            leadingIcon="delete"
            onClick={() => {
              modalActionsDeleteOutput.open()
            }}
          />
        </Flex>
        <ScrollLayout.Scroll>
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values) => {
              if (typeof values.image === "string") {
                delete values.image
              }
              if (typeof values.attachment_file === "string") {
                delete values.attachment_file
              }
              return updateOutput.mutateAsync(values as Output).then(() => {
                navigate(`/outputs/outputs`)
              })
            }}
          >
            {({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <Container fluid className="mt-6" style={{ marginBottom: "100px" }}>
                  <OutputForm />
                </Container>
                <BottomFormFixed url="/outputs/outputs" />
              </form>
            )}
          </Formik>
        </ScrollLayout.Scroll>
      </ScrollLayout>
      <ModalDelete
        isOpen={modalStateDeleteOutput.isOpen}
        onClose={modalActionsDeleteOutput.close}
        onDelete={() => {
          return deleteOutput.mutateAsync(output?.id).then(() => {
            navigate(`/outputs/outputs`)
          })
        }}
        message="Sei sicuro di voler eliminare l'output?"
        title="Elimina Output"
      />
    </Layout>
  )
}
